export const CONFIG_FIELDS = [
  { field: 'active', label: 'Active', type: 'boolean' },
  {
    field: 'label_version',
    label: 'Label Version',
    type: 'text',
    required: true,
  },
  {
    field: 'label_prefixes',
    label: 'Label Prefixes',
    type: 'list-text',
    hint: 'Separate with comma, no spaces',
    required: true,
  },
];

export const TRANSITION_FIELDS = [
  { label: 'Sort type', dataIndex: 'sort_type', type: 'string' },
  { label: 'Target regions', dataIndex: 'target_regions', type: 'array' },
  { label: 'Target warehouses', dataIndex: 'target_warehouses', type: 'array' },
  { label: 'Delivery days', dataIndex: 'delivery_days', type: 'array' },
  { label: 'Label version', dataIndex: 'label_version', type: 'string' },
];

export const SORT_TYPE_PRESORT = 'PRESORT';
export const SORT_TYPE_FINAL = 'FINAL';

export const DEFAULT_LABEL_VERSION_PRESORT = '1.0';
export const DEFAULT_LABEL_VERSION_FINAL = '3.3';
